import qs from 'qs';

const getTrackingBioLink = ({
  campaignId,
  hashtags,
  instagram,
}) => qs.stringify({
  utm_source: 'instagram',
  utm_medium: 'post',
  utm_campaign: campaignId,
  utm_term: hashtags,
  utm_content: instagram,
});


const getTrackingStoryLink = ({
  campaignId,
  hashtags,
  instagram,
}) => qs.stringify({
  utm_source: 'instagram',
  utm_medium: 'post',
  utm_campaign: campaignId,
  utm_term: hashtags,
  utm_content: instagram,
});

module.exports = {
  getTrackingBioLink,
  getTrackingStoryLink,
};



/** WEBPACK FOOTER **
 ** ./src/utils/get-tracking-links.js
 **/